import { uuidv4 } from "@firebase/util";
import { range, tail } from "ramda";
import { useEffect,  useState } from "react";
import { useTransition, animated } from "react-spring";
import randomInt from "./functions/randomInt";


// These two are just helpers, they curate spring data, values that are later being interpolated into css
const to = (i) => ({
  x: 0,
  y: i * -4,
  scale: 1,
  rot: -10 + Math.random() * 20,
  delay: i * 100,
})
const from = (_i) => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) =>
  `perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`


export const BunQueue = ({ delta, productKey, setDelta, type="1", left=0 }) => {
  const currentDelta = delta[productKey]
  const [buns, setBuns] = useState([])
  useEffect(() => {
    const i = setInterval(() => {
      // setBuns(tail)
      // setDelta(q => ({ ...q, [productKey]: Math.max(q[productKey] - 1, 0) }))
    }, 300)
    return () => {
      clearInterval(i)
    }
  }, [productKey, setDelta])
  useEffect(() => {
    if (currentDelta > buns.length) {
      const newBuns = range(0, currentDelta - buns.length).map((i) => (
        {
          i, id: uuidv4(), opacity: 0,
          "fig": i,
          "positionY": randomInt(10)(30),
          "positionX": randomInt(10)(90),
          "r": randomInt(1)(2),
          "b": randomInt(0)(1)?1:-1,
          "op": { "range": [0, 0.25, 0.75, 1], "output": [0, 1, 1, 0] },
          "trans": {
            "range": [0, 1],
            "output": [-40, 300],
            onRest: () => {
              setBuns(tail)
              setDelta(q => ({ ...q, [productKey]: Math.max(q[productKey] - 1, 0) }))
            }
          },
          "rot": {
            "range": [0, 1],
            "output": [0, 360],
          }
        }
      ))
      setBuns([...buns, ...newBuns])
    }
  }, [buns, currentDelta])

  const transitions = useTransition(buns, {
    from: { opacity: 0 },
    enter: { opacity: 0.01 },
    leave: { opacity: 1 },
    onRest: (item) => {
      setBuns(tail)
      setDelta(q => ({ ...q, [productKey]: Math.max(q[productKey] - 1, 0) }))
    },
    trail: 300,
    config: {
      mass: 2,
      friction: 5,
      tension: 5,
    }
  })

  return (
    <div className="bought" style={{ display: 'flex', left }}>
      {/* <animated.div
        className="bun moving-bun bun-2 bought-bun"
        style={{
        }}>
      </animated.div> */}
      {transitions(({ opacity }, item) => (
        <animated.div
          data-id={item.id}
          className={`bun moving-bun bun-${type} bought-bun`}
          style={{
            top: `${item.positionY}%`,
            left: `${item.positionX}%`,
            // position: `${item.positionX}% ${item.positionY}%`,
            opacity: opacity.to(item.op),
            transform: opacity
              .to(item.trans)
              .to(y => `translate3d(0,${y}px,0) rotate(${item.b *(y*item.r)}deg)`),
          }}>
        </animated.div>
      ))}
    </div>
  )
};
